import React, { useEffect, useState, useCallback } from 'react';
import api from '../../api/client';
import Button from '../../components/Button';

// Turnierformate, die eine visuelle Bracket-Anzeige haben (Scoreboard-Formate haben keinen Turnierbaum)
const BRACKET_FORMATS = ['single_elimination', 'double_elimination', 'seeded_single_elimination'];

function LinkRow({ label, sublabel, path, copied, onCopy }) {
  const url = `${window.location.origin}${path}`;
  return (
    <div className="card flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="font-semibold text-slate-800">{label}</p>
        {sublabel && <p className="text-xs text-slate-400">{sublabel}</p>}
        <p className="text-xs text-ocean-600 font-mono truncate mt-0.5">{url}</p>
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <Button size="sm" variant="secondary" onClick={() => onCopy(path, url)}>
          {copied === path ? '✓ Kopiert' : '🔗 Link kopieren'}
        </Button>
        <Button size="sm" variant="ghost" onClick={() => window.open(path, '_blank')}>
          Vorschau
        </Button>
      </div>
    </div>
  );
}

export default function AdminLinks() {
  const [events, setEvents] = useState([]);
  const [tournamentsByEvent, setTournamentsByEvent] = useState({});
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    api.get('/api/events/all').then(async (r) => {
      const evs = r.data;
      setEvents(evs);
      const entries = await Promise.all(
        evs.map((ev) => api.get(`/api/events/${ev.id}/tournaments`).then((res) => [ev.id, res.data]).catch(() => [ev.id, []]))
      );
      setTournamentsByEvent(Object.fromEntries(entries));
    }).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const copy = (path, url) => {
    navigator.clipboard.writeText(url);
    setCopied(path);
    setTimeout(() => setCopied(null), 2000);
  };

  if (loading) return (
    <div className="flex justify-center py-16">
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-ocean-400 border-t-transparent" />
    </div>
  );

  const bracketTournaments = events.flatMap((ev) =>
    (tournamentsByEvent[ev.id] || [])
      .filter((t) => BRACKET_FORMATS.includes(t.format))
      .map((t) => ({ event: ev, tournament: t }))
  );

  return (
    <div>
      <h2 className="page-title">Anzeige-Links</h2>
      <p className="text-sm text-slate-500 mb-6 max-w-2xl">
        Diese Seiten sind für Beamer/TV-Anzeigen gedacht (z.B. per Anthias an Clients verteilt) und haben
        bewusst keinen Link in der normalen Navigation. Hier findest du alle URLs zum Kopieren.
      </p>

      <div className="mb-8">
        <p className="section-title mb-3">Feste Anzeigen</p>
        <div className="space-y-2">
          <LinkRow label="Sponsoren-Anzeige" sublabel="Rotierende Sponsoren-Slideshow" path="/sponsor-show" copied={copied} onCopy={copy} />
          <LinkRow label="Bingo-Ziehung" sublabel="Live-Anzeige der gezogenen Zahlen" path="/bingo-show" copied={copied} onCopy={copy} />
          <LinkRow label="Infos-Anzeige" sublabel="Netzwerk, Server-IPs & sonstige Hinweise" path="/info-show" copied={copied} onCopy={copy} />
        </div>
      </div>

      <div className="mb-8">
        <p className="section-title mb-3">Timetable je Event</p>
        {events.length === 0 ? (
          <div className="card text-center py-8 text-slate-400 text-sm">Noch keine Events vorhanden.</div>
        ) : (
          <div className="space-y-2">
            {events.map((ev) => (
              <LinkRow key={ev.id} label={ev.name} sublabel="Timetable-Anzeige"
                path={`/timetable-show/${ev.id}`} copied={copied} onCopy={copy} />
            ))}
          </div>
        )}
      </div>

      <div>
        <p className="section-title mb-3">Turnierbaum je Turnier</p>
        {bracketTournaments.length === 0 ? (
          <div className="card text-center py-8 text-slate-400 text-sm">
            Keine Turniere mit Turnierbaum-Anzeige vorhanden.
          </div>
        ) : (
          <div className="space-y-2">
            {bracketTournaments.map(({ event, tournament }) => (
              <LinkRow key={tournament.id} label={tournament.name} sublabel={event.name}
                path={`/bracket-show/${tournament.id}`} copied={copied} onCopy={copy} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
